import axios from 'axios';
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';
import { getCookie } from 'utils/cookies';

const logOut = async (contextConfiguration) => {
	const token = getCookie('authToken');
    
	if (token) {
		const headers = {
			...commonConfiguration.headers,
			Authorization: `Token ${token}`,
			'X-Requested-With': 'XMLHttpRequest'
		};

		if (contextConfiguration && contextConfiguration.headers) 
			Object.assign(headers, contextConfiguration.headers);
        

		await axios.post(
			'/log-out',
			{},
			{
				...commonConfiguration,
				...contextConfiguration,
				headers
			}
		).catch(() => {});
	}

	document.cookie = 'authToken=; Max-Age=0; path=/;';
};

export default logOut;
